<template>
  <div class="vote-image-container">
    <question v-bind="{ poll, question }" ref="question"/>
    <flex-two-columns v-if="question.image || (poll.isDisplayed && isPieChart)">
      <question-image v-if="question.image" :question="question" :headerHeight="headerHeight">
        <pie-chart
          v-if="poll.isDisplayed && isPieChart"
          :stats="statsOfQuestion"
          :poll="poll"
          class="pie-chart-with-image"
        ></pie-chart>
      </question-image>
      <pie-chart v-else-if="isPieChart" :stats="statsOfQuestion" :poll="poll" class="pie-chart-without-image"></pie-chart>
      <answers
        v-if="headerHeight > 0"
        v-bind="{
            answers,
            question,
            stats: statsOfQuestion,
            poll,
            headerHeight
          }"
      />
    </flex-two-columns>
    <div v-else>
      <answers
        v-if="headerHeight > 0"
        v-bind="{
        answers,
        question,
        stats: statsOfQuestion,
        poll,
        headerHeight
      }"
      />
    </div>
  </div>
</template>

<script>
import CommonMixin from '../mixins/common.js';
import Question from '../components/Question.vue';
import QuestionImage from '../components/QuestionImage.vue';
import FlexTwoColumns from '../components/FlexTwoColumns.vue';
import Answers from '../components/Answers.vue';
import PieChart from '../components/PieChart.vue';

export default {
  name: 'imagevote',
  components: {
    Answers,
    Question,
    QuestionImage,
    FlexTwoColumns,
    PieChart
  },
  props: {
    ...CommonMixin.props
  },
  data: () => ({
    headerHeight: 0
  }),
  computed: {
    ...CommonMixin.computed,
    isPieChart() {
      return this.poll.jsStyle.graphType.value === 'pie_chart' || this.poll.jsStyle.graphType.value === 'doughnut_chart';
    },
    statsOfQuestion() {
      return this.$store.getters.statsOfQuestion(this.question.questionId);
    }
  },
  methods: {
    ...CommonMixin.methods,
    setHeaderHeight() {
      // we can't use a computed property for the headerHeight because $refs are not reactive
      this.headerHeight = this.$refs.question.$el.clientHeight;
    }
  },
  mounted() {
    this.setHeaderHeight();
  },
  watch: {
    question() {
      this.setHeaderHeight();
    }
  }
};
</script>

<style lang="scss" scoped>
.vote-image-container {
  height: 100%;
}

.pie-chart-with-image {
  // position: absolute;
  // bottom: 60px;
  // right: 0;
  // height: 300px;
  // width: 700px;
}

.pie-chart-without-image {
  //margin-top: 10%;
}
</style>
